import { useHistory } from "react-router-dom";
import { Box, TextField, Button } from "@mui/material";

export const PasswordResetSuccess = () => {
  const history = useHistory();

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1 style={{ color: "#3366BB" }}>Success!</h1>

      <p>
        Your password has been reset, now please login with your new password.
      </p>
      <Button
        variant="contained"
        sx={{ width: "300px", mt: 2 }}
        onClick={() => history.push("/login")}
      >
        Log in
      </Button>
    </Box>
  );
};
